/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import axios from '@/api';

function setReadEmail(email_id) {
  return axios.put(`user/communications/${email_id}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function getInboxEmail(email_id) {
  return axios.get(`user/communications/${email_id}/in`)
    .then((response) => {
      if (response.data.is_read === 0) {
        return setReadEmail(email_id)
          .then(() => response.data)
          .catch(error => Promise.reject(error));
      }
      return response.data;
    })
    .catch(error => Promise.reject(error));
}

function getOutboxEmail(email_uuid) {
  return axios.get(`user/communications/${email_uuid}/out`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

/* teacher part  */

function getTeacherInbox(classroom_id) {
  return axios.get(`teacher/communications/in?classroom_id=${classroom_id}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function getTeacherCount(classroom_id) {
  return axios.get(`teacher/communications/count?classroom_id=${classroom_id}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function getTeacherOutbox(classroom_id) {
  return axios.get(`teacher/communications/out?classroom_id=${classroom_id}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function recipientsList(classroom_id) {
  return axios.get(`teacher/communications/receivers/${classroom_id}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function createTeacherCommunication({
  receivers,
  subject,
  message,
  notify,
  classroom_id,
}) {
  return axios.post('teacher/communications', {
      receivers,
      subject,
      message,
      notify,
      classroom_id,
    })
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

/* tutor part  */
function getTutorInbox(minorId) {
  return axios.get(`tutor/communications/in?minor_id=${minorId}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function getTutorOutbox(minorId) {
  return axios.get(`tutor/communications/out?minor_id=${minorId}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function createTutorCommunication({
  minor_id,
  subject,
  message,
  notify,
  classroom_id,
}) {
  return axios.post('tutor/communications', {
      minor_id,
      subject,
      message,
      notify,
      classroom_id,
    })
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function getTutorCount(minor_id) {
  return axios.get(`tutor/communications/count?minor_id=${minor_id}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

async function deleteCommunication(communication_id) {
  return axios.delete(`user/communications/${communication_id}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

export const communicationService = {
  getTeacherInbox,
  getTeacherCount,
  getTeacherOutbox,
  getTutorInbox,
  getOutboxEmail,
  getInboxEmail,
  setReadEmail,
  getTutorOutbox,
  recipientsList,
  createTeacherCommunication,
  createTutorCommunication,
  getTutorCount,
  deleteCommunication,
};
